import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

interface IDoc {
  name: string;
  path: string;
  desc: string;
  doc_icon: EDocIcon;
};

enum EDocIcon {
  PDF = "picture_as_pdf",
  VIDEO = "movie",
  IMAGE = "image",
  DOC = "edit_document",
  OTHER = "file_present"
}

@Component({
  selector: 'app-docs',
  imports: [
    MatCardModule,
    MatIconModule,
  ],
  templateUrl: './docs.component.html',
  styleUrl: './docs.component.scss'
})
export class DocsComponent {
  public docs: IDoc[] = [
    {
      name: 'User Manual',
      path: 'docs/CtrlKey User Manual - Customer.pdf',
      desc: 'Manual which covers all aspects of the Ctrl key tool in detail',
      doc_icon: EDocIcon.PDF
    },
    {
      name: 'Admin Manual',
      path: 'docs/CtrlKey User Manual - Admin.pdf',
      desc: 'Manual which covers all aspects of the Ctrl key tool in detail for site administrators',
      doc_icon: EDocIcon.PDF
    },
    {
      name: 'Expense Workflow',
      path: 'docs/Workflow - Expense Assigner.pdf',
      desc: 'Manual which covers how to assign expenses to a project in greater detail',
      doc_icon: EDocIcon.PDF
    },
    {
      name: 'Expense Flowchart',
      path: 'docs/Workflow - Expense Assigner Summary.pdf',
      desc: 'Quick reference flowchart for how to assign expenses to a project',
      doc_icon: EDocIcon.PDF
    },
    {
      name: 'Assignment Workflow',
      path: 'docs/Workflow - Work Assigner.pdf',
      desc: 'Manual which covers how to assign work to contractors in greater detail',
      doc_icon: EDocIcon.PDF
    },
    {
      name: 'Assignment Flowchart',
      path: 'docs/Workflow - Work Assigner Summary.pdf',
      desc: 'Quick reference flowchart for how to assign work to contractors',
      doc_icon: EDocIcon.PDF
    },
    {
      name: 'Product Demo',
      path: 'https://www.youtube.com/watch?v=g8EUhHOMcKA',
      desc: 'Product demonstration showing some of the key features',
      doc_icon: EDocIcon.VIDEO
    }
  ];

  /**
   * Open the document path
   *
   * @param path  document path
   */
  public openDoc(path: string): void {
    window.open(path, '_blank');
  }
}
